// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__aQc3m","content":"styles_content__gkpiF"};